export const EMPLOYEES = [
  { id: 1, name: 'Alice Chen',      role: 'Product Designer',    dept: 'Design',      avatar: 'AC', color: '#7C3AED', balance: 25, used: 8,  pending: 3 },
  { id: 2, name: 'Marcus Webb',     role: 'Senior Engineer',     dept: 'Engineering', avatar: 'MW', color: '#2D6A4F', balance: 25, used: 12, pending: 0 },
  { id: 3, name: 'Priya Nair',      role: 'Engineering Manager', dept: 'Engineering', avatar: 'PN', color: '#E76F51', balance: 30, used: 5,  pending: 2 },
  { id: 4, name: "James O'Brien",   role: 'Account Executive',   dept: 'Sales',       avatar: 'JO', color: '#0369A1', balance: 25, used: 18, pending: 1 },
  { id: 5, name: 'Sofia Martinez',  role: 'HR Specialist',       dept: 'HR',          avatar: 'SM', color: '#B45309', balance: 25, used: 3,  pending: 0 },
  { id: 6, name: 'Lucas Tan',       role: 'Data Analyst',        dept: 'Analytics',   avatar: 'LT', color: '#BE185D', balance: 25, used: 7,  pending: 4 },
  { id: 7, name: 'Emily Zhao',      role: 'Frontend Engineer',   dept: 'Engineering', avatar: 'EZ', color: '#0F766E', balance: 25, used: 2,  pending: 1 },
  { id: 8, name: 'Daniel Okafor',   role: 'Sales Manager',       dept: 'Sales',       avatar: 'DO', color: '#1D4ED8', balance: 28, used: 10, pending: 0 },
];

let _rid = 200;
const rid = () => _rid++;

export const REQUESTS_INIT = [
  { id: rid(), empId: 1, type: 'Annual Leave',     from: '2025-08-01', to: '2025-08-05', days: 5,  status: 'pending',  note: 'Summer holiday' },
  { id: rid(), empId: 1, type: 'Annual Leave',     from: '2025-07-10', to: '2025-07-12', days: 3,  status: 'approved', note: 'Conference trip' },
  { id: rid(), empId: 1, type: 'Sick Leave',       from: '2025-06-03', to: '2025-06-03', days: 1,  status: 'approved', note: '' },
  { id: rid(), empId: 2, type: 'Sick Leave',       from: '2025-07-08', to: '2025-07-09', days: 2,  status: 'approved', note: '' },
  { id: rid(), empId: 2, type: 'Annual Leave',     from: '2025-09-15', to: '2025-09-26', days: 10, status: 'pending',  note: 'Family vacation' },
  { id: rid(), empId: 3, type: 'Annual Leave',     from: '2025-06-20', to: '2025-06-22', days: 3,  status: 'approved', note: 'Wedding' },
  { id: rid(), empId: 3, type: 'Remote Work',      from: '2025-08-11', to: '2025-08-15', days: 5,  status: 'pending',  note: 'Work from abroad' },
  { id: rid(), empId: 4, type: 'Annual Leave',     from: '2025-07-28', to: '2025-08-08', days: 10, status: 'approved', note: 'Summer trip' },
  { id: rid(), empId: 4, type: 'Annual Leave',     from: '2025-05-01', to: '2025-05-05', days: 5,  status: 'approved', note: 'Bank holiday break' },
  { id: rid(), empId: 4, type: 'Annual Leave',     from: '2025-10-06', to: '2025-10-10', days: 5,  status: 'pending',  note: 'Autumn break' },
  { id: rid(), empId: 5, type: 'Annual Leave',     from: '2025-08-25', to: '2025-08-27', days: 3,  status: 'approved', note: '' },
  { id: rid(), empId: 6, type: 'Annual Leave',     from: '2025-07-01', to: '2025-07-04', days: 4,  status: 'approved', note: 'Independence week' },
  { id: rid(), empId: 6, type: 'Annual Leave',     from: '2025-09-01', to: '2025-09-05', days: 5,  status: 'pending',  note: 'Late summer' },
  { id: rid(), empId: 6, type: 'Remote Work',      from: '2025-08-18', to: '2025-08-22', days: 5,  status: 'pending',  note: 'Remote sprint' },
  { id: rid(), empId: 7, type: 'Annual Leave',     from: '2025-09-22', to: '2025-09-26', days: 5,  status: 'pending',  note: 'Holiday' },
  { id: rid(), empId: 8, type: 'Annual Leave',     from: '2025-07-21', to: '2025-07-25', days: 5,  status: 'approved', note: '' },
];

export const LEAVE_TYPES = [
  'Annual Leave',
  'Sick Leave',
  'Remote Work',
  'Unpaid Leave',
  'Compassionate Leave',
  'Parental Leave',
];

export const DEPARTMENTS = ['All', 'Design', 'Engineering', 'Sales', 'HR', 'Analytics'];

export const PUBLIC_HOLIDAYS_2025 = [
  { date: '2025-01-01', name: "New Year's Day" },
  { date: '2025-04-18', name: 'Good Friday' },
  { date: '2025-04-21', name: 'Easter Monday' },
  { date: '2025-05-05', name: 'Early May Bank Holiday' },
  { date: '2025-05-26', name: 'Spring Bank Holiday' },
  { date: '2025-08-25', name: 'Summer Bank Holiday' },
  { date: '2025-12-25', name: 'Christmas Day' },
  { date: '2025-12-26', name: 'Boxing Day' },
];

export const LEAVE_POLICY_DEFAULT = {
  annualDays:     25,
  sickDays:       10,
  carryOver:       5,
  noticeWeeks:     2,
  maxConsecutive: 15,
};
